import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import IFCFileDeleteButton from '@editor/components/IFCAlignmentForm/components/IFCFileDeleteButton'
import IFCFileTitleField from '@editor/components/IFCAlignmentForm/components/IFCFileTitleField'
import { CorneredSection } from '@ui2/structure'
import useIFCImportSettings from '../../hooks/useIFCImportSettings'

/**
 * Settings for the selected IFC model, shown in the IFC Import drawer: the title field and the
 * delete button (mirroring the IFC widget's "Einstellungen" tab).
 */
const IFCSettingsPanel = (): ReactElement => {
  const { closeSettings } = useIFCImportSettings()

  return (
    <CorneredSection>
      <Stack spacing={1}>
        <IFCFileTitleField />
        <Stack direction="row" justifyContent="flex-end">
          <IFCFileDeleteButton onDeleted={closeSettings} />
        </Stack>
      </Stack>
    </CorneredSection>
  )
}

export default IFCSettingsPanel
